import { render, staticRenderFns } from "./organization-create.vue?vue&type=template&id=b120ae60&"
import script from "./organization-create.vue?vue&type=script&lang=js&"
export * from "./organization-create.vue?vue&type=script&lang=js&"
import style0 from "./organization-create.vue?vue&type=style&index=0&id=b120ae60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports